/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractTenantDocument } from './ContractTenantDocument';
import {
    ContractTenantDocumentFromJSON,
    ContractTenantDocumentFromJSONTyped,
    ContractTenantDocumentToJSON,
    ContractTenantDocumentToJSONTyped,
} from './ContractTenantDocument';
import type { ContractGuarantor } from './ContractGuarantor';
import {
    ContractGuarantorFromJSON,
    ContractGuarantorFromJSONTyped,
    ContractGuarantorToJSON,
    ContractGuarantorToJSONTyped,
} from './ContractGuarantor';
import type { TenantSeniorityStatusEnum } from './TenantSeniorityStatusEnum';
import {
    TenantSeniorityStatusEnumFromJSON,
    TenantSeniorityStatusEnumFromJSONTyped,
    TenantSeniorityStatusEnumToJSON,
    TenantSeniorityStatusEnumToJSONTyped,
} from './TenantSeniorityStatusEnum';

/**
 * 
 * @export
 * @interface ContractTenant
 */
export interface ContractTenant {
    /**
     * 
     * @type {string}
     * @memberof ContractTenant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContractTenant
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractTenant
     */
    civilityId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractTenant
     */
    isCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractTenant
     */
    isEligible: boolean;
    /**
     * 
     * @type {ContractGuarantor}
     * @memberof ContractTenant
     */
    guarantor?: ContractGuarantor;
    /**
     * 
     * @type {Array<ContractTenantDocument>}
     * @memberof ContractTenant
     */
    documents: Array<ContractTenantDocument>;
    /**
     * 
     * @type {TenantSeniorityStatusEnum}
     * @memberof ContractTenant
     */
    seniorityStatus?: TenantSeniorityStatusEnum;
    /**
     * Déclaration « à jour de ses loyers » (locataire en place) — null si jamais déclaré
     * @type {boolean}
     * @memberof ContractTenant
     */
    rentPaymentsUpToDate?: boolean | null;
}



/**
 * Check if a given object implements the ContractTenant interface.
 */
export function instanceOfContractTenant(value: object): value is ContractTenant {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('isEligible' in value) || value['isEligible'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function ContractTenantFromJSON(json: any): ContractTenant {
    return ContractTenantFromJSONTyped(json, false);
}

export function ContractTenantFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractTenant {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'civilityId': json['civilityId'],
        'isCompleted': json['isCompleted'],
        'isEligible': json['isEligible'],
        'guarantor': json['guarantor'] == null ? undefined : ContractGuarantorFromJSON(json['guarantor']),
        'documents': ((json['documents'] as Array<any>).map(ContractTenantDocumentFromJSON)),
        'seniorityStatus': json['seniorityStatus'] == null ? undefined : TenantSeniorityStatusEnumFromJSON(json['seniorityStatus']),
        'rentPaymentsUpToDate': json['rentPaymentsUpToDate'] == null ? undefined : json['rentPaymentsUpToDate'],
    };
}

export function ContractTenantToJSON(json: any): ContractTenant {
    return ContractTenantToJSONTyped(json, false);
}

export function ContractTenantToJSONTyped(value?: ContractTenant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'civilityId': value['civilityId'],
        'isCompleted': value['isCompleted'],
        'isEligible': value['isEligible'],
        'guarantor': ContractGuarantorToJSON(value['guarantor']),
        'documents': ((value['documents'] as Array<any>).map(ContractTenantDocumentToJSON)),
        'seniorityStatus': TenantSeniorityStatusEnumToJSON(value['seniorityStatus']),
        'rentPaymentsUpToDate': value['rentPaymentsUpToDate'],
    };
}

